<template>
  <lf-heading3
    class="flex items-center space-x-2"
    data-cy="document-retrieval-header"
  >
    <icon-base :icon="IconDocuments" viewBox="0 0 17 17" class="text-label" />
    <span class="leading-none">
      {{ $t("DEALS.DOCUMENTS.DOCUMENT_RETRIEVAL") }}
    </span>
  </lf-heading3>
  <template v-for="record in data">
    <template v-for="(data, key, index) in record">
      <corporate-record
        v-if="key === 'CorporateRecord'"
        :key="`corporate_${key}_${index}`"
        :data="narrowCorporateData(data)"
      />
      <document-section
        v-else-if="prepareData(data, key)"
        :key="`document_${key}_${index}`"
        :section="prepareData(data, key)"
      />
    </template>
  </template>
</template>

<script setup lang="ts">
import {
  prepareBusinessProfileRecord,
  prepareFeinData,
  preparePhoneRecord,
} from "@/helpers/clear";

import CorporateRecord from "@/components/deals/dataServices/components/clear/documentRetrieval/CorporateRecord.vue";
import DocumentSection from "@/components/deals/dataServices/components/clear/documentRetrieval/DocumentSection.vue";
import IconDocuments from "@/components/icons/sidebar/deals/IconDocuments.vue";
import LfHeading3 from "@/components/ui/text/LfHeading3.vue";

import type {
  BusinessProfileRecord,
  CorporateFilingItem,
  DocumentRetrievalResponseDetail,
  DunBradstreetRecord,
  FederalEmployerIDRecord,
  PhoneRecord,
  WorldbaseRecord,
} from "@/models/commercialData/clear/ClearIdConfirmBusiness";

defineProps<{
  data: DocumentRetrievalResponseDetail[];
}>();

const narrowCorporateData = (
  data:
    | CorporateFilingItem
    | BusinessProfileRecord
    | PhoneRecord
    | FederalEmployerIDRecord
    | WorldbaseRecord
    | DunBradstreetRecord
    | undefined
) => {
  return data as CorporateFilingItem;
};

const prepareData = (
  data:
    | CorporateFilingItem
    | BusinessProfileRecord
    | PhoneRecord
    | FederalEmployerIDRecord
    | WorldbaseRecord
    | DunBradstreetRecord
    | undefined,
  key: keyof DocumentRetrievalResponseDetail
) => {
  let returnVal = undefined;
  switch (key) {
    case "BusinessProfileRecord":
      returnVal = prepareBusinessProfileRecord(data as BusinessProfileRecord);
      break;
    case "PhoneRecord":
      returnVal = preparePhoneRecord(data as PhoneRecord);
      break;
    case "FederalEmployerIDRecord":
      returnVal = prepareFeinData(data as FederalEmployerIDRecord);
      break;
    default:
      break;
  }
  return returnVal;
};
</script>
